<!-- @format -->

<ng-container *transloco="let t">
  <button type="button" class="modal-close" (click)="this.activeModal.dismiss()" [attr.aria-label]="t('ARIA_LABEL.CLOSE')">
    <sis-icon icon="ring-close"></sis-icon>
  </button>
</ng-container>
